import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=76cd7708"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style1 from "./../css/themes/default/header.scss?vue&type=style&index=1&prod&lang=scss&module=theme_default&external"
import style2 from "./../css/themes/simple/header.scss?vue&type=style&index=2&prod&lang=scss&module=theme_simple&external"




function injectStyles (context) {
  
  this["theme_default"] = (style1.locals || style1)
this["theme_simple"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports